<br>
<div class="col-md-12">
  <p-table #dt [columns]="cols" [value]="officecommittees" [paginator]="false" [autoLayout]="true">
    <ng-template pTemplate="caption">
      <p class="rubrik">Hantera Office Committee</p>
      <div class="d-flex justify-content-start gap-2"><button class="btn border" (click)="resetFilter()" title="Rensa filter">Rensa filter</button><button class="btn border"
            (click)="exportToCSV()">Excel</button><button class="btn btn-border" (click)="addOfficeCommittee()">Lägg till</button></div>
      <br>
      <div>
        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
        <input type="text" #globalfilter pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
      <span class="ms-2">Antal poster: {{officecommittees?.length}}</span>
      
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr style="background-color: whitesmoke;font-weight:bold;border:1px solid lightgrey;">
        <td colspan="2" style="border:1px solid lightgrey;">Ämbete</td>
        <td colspan="2" style="border:1px solid lightgrey;">Utskott</td>
        <td colspan="2" style="border:1px solid lightgrey;"></td>
      </tr>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
          </p-sortIcon>
        </th>
        <th>Action</th>
      </tr>
      <tr>
        <th *ngFor="let col of columns" [ngSwitch]="col.field">
          <input *ngSwitchCase="'officeName'" pInputText type="text" [value]="dt.filters['officeName'] ? dt.filters['officeName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'officeAbbreviation'" pInputText type="text" [value]="dt.filters['officeAbbreviation'] ? dt.filters['officeAbbreviation'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'committeeName'" pInputText type="text" [value]="dt.filters['committeeName'] ? dt.filters['committeeName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'committeeAbbreviation'" pInputText type="text" [value]="dt.filters['committeeAbbreviation'] ? dt.filters['committeeAbbreviation'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns">
          {{rowData[col.field]}}
        </td>
        <td style="text-align: center;"><i class="fa fa-trash" style="font-size:12px;" (click)="remove(rowData)" title="Radera"></i></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog header="Lägg till Office Committee" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-office-committees-add [formdata]="formdata" [offices]="offices" [committees]="committees" (doSave)="saveOfficeCommittees($event)" (doCancel)="cancelAdd()"></app-admin-office-committees-add>
</p-dialog>